import { render, staticRenderFns } from "./ListRequest.vue?vue&type=template&id=9b08d0fa&scoped=true&"
import script from "./ListRequest.vue?vue&type=script&lang=js&"
export * from "./ListRequest.vue?vue&type=script&lang=js&"
import style0 from "./ListRequest.vue?vue&type=style&index=0&id=9b08d0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b08d0fa",
  null
  
)

export default component.exports